import axios, { getData } from "lib/axios";

export const postCheckLeaveBulkImport = async (data) => {
  return await axios.post("admin/entitlement/view-import?mode=upsert", data).then(getData);
};

export const postSendLeaveBulkImport = async (data) => {
  return await axios.post("admin/entitlement/import?mode=upsert", data).then(getData);
};

export const postCheckLeaveDetailsBulkImport = async (data) => {
  return await axios.post("admin/leave/staff-upload", data).then(getData);
};

export const postSendLeaveDetailsBulkImport = async (data) => {
  return await axios.post("admin/leave/staff-import", data).then(getData);
};
